/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { Image, Platform, StyleSheet, View, ScrollView, Dimensions } from 'react-native';
import { Menu, MenuOption, MenuOptions, MenuTrigger, renderers } from 'react-native-popup-menu';
import Customtext from '../customText';

const screenWidth = Dimensions.get('window').width;
const image = require('../../assets/images/info.png');

const { Popover, SlideInMenu } = renderers;

const styles = StyleSheet.create({
  infoTipforScroll: {
    shadowColor: 'black',
    shadowOpacity: 0.1,
    shadowOffset: { width: 0, height: 0 },
    shadowRadius: 5,
    borderWidth: 0,
    maxHeight: 300,
    borderRadius: 4,
    backgroundColor: 'black',

    width: screenWidth > 350 ? 300 : 250
  },
  infoTip: {
    shadowColor: 'black',
    shadowOpacity: 0.1,
    shadowOffset: { width: 0, height: 0 },
    shadowRadius: 5,
    borderWidth: 0,
    maxHeight: 100,
    borderRadius: 4,
    backgroundColor: 'black',
    width: 200
  },
  menuOptions: {
    shadowColor: 'black',
    shadowOpacity: 0.1,
    shadowOffset: { width: 0, height: 0 },
    shadowRadius: 5,
    borderWidth: 0,

    borderRadius: 4,
    backgroundColor: 'black'
  },
  contentText: {
    paddingHorizontal: 8,
    paddingVertical: 3,
    color: 'white',
    fontSize: 12,
    fontWeight: '400',
    lineHeight: 17
  },
  viewFooterTxt: {
    marginTop: 5
  },
  scrollViewStyle: {
    maxHeight: 100
  }
});

class InfoTip extends Component {
  handleKeyDown = event => {
    switch (event.keyCode) {
      case 38: // up arrow key
      case 40: // down arrow key
        event.preventDefault();
        break;
      default:
        break;
    }
  };

  openMenu = () => {
    const { onMenuOpen } = this.props;
    if (onMenuOpen) {
      onMenuOpen();
    }
    if (Platform.OS === 'web') {
      document.addEventListener('keydown', this.handleKeyDown);
    }
  };

  closeMenu = () => {
    const { onMenuClose } = this.props;
    if (onMenuClose) {
      onMenuClose();
    }
    if (Platform.OS === 'web') {
      document.removeEventListener('keydown', this.handleKeyDown);
    }
  };

  render() {
    const { preferredPlacement, placement, OptionsField, onMenuOpen, propRenderer, anchorStyle, styleMenuOptions, children, menuStyle, onMenuClose, onSelect, ref, isHeader, headerTxt, footerTxt, width_height } = this.props;

    return (
      <View>
        <Menu
          style={menuStyle}
          onOpen={this.openMenu}
          onClose={this.closeMenu}
          onSelect={onSelect}
          ref={ref}
          renderer={propRenderer || Popover || SlideInMenu}
          rendererProps={{
            preferredPlacement: preferredPlacement || 'top',
            placement,
            anchorStyle: [
              {
                backgroundColor: 'black'
              },
              anchorStyle
            ]
          }}>
          <MenuTrigger>
            {children || (
              <Image
                source={image}
                style={{
                  width: width_height ? width_height : 20,
                  height: width_height ? width_height : 20
                }}></Image>
            )}
          </MenuTrigger>

          <MenuOptions optionsContainerStyle={isHeader ? [styles.menuOptions, styleMenuOptions] : [OptionsField.length < 150 ? [styles.infoTip, styleMenuOptions] : [styles.infoTipforScroll, styleMenuOptions]]}>
            <MenuOption>
              <View>
                <View>
                  {isHeader ? (
                    <View>{typeof OptionsField === 'string' ? <Customtext style={styles.contentText}>{OptionsField}</Customtext> : OptionsField}</View>
                  ) : (
                      // View for Info-Tip
                      <View>{typeof OptionsField === 'string' ? <Customtext style={styles.contentText}>{OptionsField}</Customtext> : OptionsField}</View>
                    )}
                </View>
              </View>
            </MenuOption>
          </MenuOptions>
        </Menu>
      </View>
    );
  }
}

export default InfoTip;
